/*
 * ******************************************************************************
 * Copyright Innov'ATM all rights reserved. This software is the property of
 * Innov'ATM and may not be used in any manner except under a license agreement
 * signed with Innov'ATM.
 * *******************************************************************************
 */

import { Box } from '@mui/material';
import { format as originalFormat } from 'date-fns';
import { memo } from 'react';

import { useQueryGetGetFlights } from '../../../../../backend';
import { useRmsGanttValue } from '../../RmsContext';
import { ganttDayFormat, ganttPxPerMs } from '../gantt.constants';
import { bounded } from '../gantt.utils';
import { GanttOverCapacityAlert } from './GanttOverCapacityAlert.style';

export const GanttOverCapacityAlerts = memo(function GanttOverCapacityAlerts({
    resourceName,
}: {
    resourceName: string;
}) {
    const resourceType = useRmsGanttValue('resourceType');
    const day = useRmsGanttValue('day');
    const dayBounds = useRmsGanttValue('dayBounds');

    const { data: ganttDto } = useQueryGetGetFlights({
        selectedDay: originalFormat(day, ganttDayFormat),
        selectedResourceType: resourceType,
    });
    const conflicts = ganttDto?.conflicts?.filter(c => c.resource === resourceName);

    return (
        <Box sx={{ opacity: '0.6' }} position={'absolute'} height={'100%'} top={0}>
            {conflicts &&
                conflicts.map(({ from: begin, to: end }) => (
                    <GanttOverCapacityAlert
                        key={resourceName + begin + end}
                        from={bounded(begin, dayBounds?.from, dayBounds?.to)}
                        to={bounded(end, dayBounds?.from, dayBounds?.to)}
                        left={(bounded(begin, dayBounds?.from, dayBounds?.to) - dayBounds?.from) * ganttPxPerMs * 2}
                    />
                ))}
        </Box>
    );
});
